import script from "./InterpretationGame.vue?vue&type=script&setup=true&lang=js"
export * from "./InterpretationGame.vue?vue&type=script&setup=true&lang=js"

import "./InterpretationGame.vue?vue&type=style&index=0&id=2b8c5956&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b8c5956"]])

export default __exports__